const Home = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.073 4.07a1.5 1.5 0 0 1 1.854 0l5.618 4.415a2.5 2.5 0 0 1 .955 1.965v7.028a2.5 2.5 0 0 1-2.5 2.5H7a2.5 2.5 0 0 1-2.5-2.5V10.45a2.5 2.5 0 0 1 .955-1.965zm1.236.787a.5.5 0 0 0-.618 0L6.073 9.27a1.5 1.5 0 0 0-.573 1.18v7.027a1.5 1.5 0 0 0 1.5 1.5h1.75v-4.5a1.5 1.5 0 0 1 1.5-1.5h3.5a1.5 1.5 0 0 1 1.5 1.5v4.5H17a1.5 1.5 0 0 0 1.5-1.5V10.45a1.5 1.5 0 0 0-.573-1.18zm1.941 14.121v-4.5a.5.5 0 0 0-.5-.5h-3.5a.5.5 0 0 0-.5.5v4.5z"
      clipRule="evenodd"
    />
  </>
)
export default Home
